import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { SampleRequestNewComponent } from './features/sample-request/sample-request-new.component';
import { LoginComponent } from './features/admin/login/login.component';
import { HomeComponent } from './features/admin/home/home.component';


import { AdminBudgetReportComponent } from './features/admin/sample-request-admin/admin-budget-report/admin-budget-report.component';



import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';
import { SampleRequestOrderHistoryComponent } from './features/admin/sample-request-order-history/sample-request-order-history.component';
import { SampleRequestOrderDetailsComponent } from './features/admin/sample-request-order-details/sample-request-order-details.component';
import { SampleRequestInventoryUsageReportComponent } from './features/admin/sample-request-inventory-usage-report/sample-request-inventory-usage-report.component';

import { ChangePasswordComponent } from './features/change-password/change-password.component';
import { homedir } from 'os';

const routes: Routes = [
  // Site routes goes here
  {
    path: 'home',
    component: SampleRequestNewComponent,
    data: { breadcrumb: 'no-bread-crumb' },

  },
  // otherwise redirect to home
  {
    path: '',
    redirectTo: 'home',
    data: { breadcrumb: 'no-bread-crumb' },
    pathMatch: 'full',
  }, 
  //#Region Sample Admin
  {
    path: 'sample-request-admin',
    data: { breadcrumb: 'no-bread-crumb' },
    children: [
      {
        path: '',
        component: LoginComponent,
        data: { breadcrumb: 'no-bread-crumb' },
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { breadcrumb: 'no-bread-crumb' },
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        //add auth here
        data: { breadcrumb: 'no-bread-crumb' },
      },
      {
        path: 'admin-budget-report',
        component: AdminBudgetReportComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Budget/Allocation Reports' },
      },
      {
        path: 'sample-request-order-history',
        canActivate: [AuthGuard],
        component: SampleRequestOrderHistoryComponent,
        data: { breadcrumb: 'Order History' }
      },
      {
        path: 'sample-request-order-history2/order-details/:orderId',
        canActivate: [AuthGuard],
        component: SampleRequestOrderDetailsComponent,
        data: { breadcrumb: ['Order Details'] },
      },
      {
        path: 'sample-request-inventory-usage-report',
        canActivate: [AuthGuard],
        component: SampleRequestInventoryUsageReportComponent,
        data: { breadcrumb: 'Inventory/Usage Report' }
      }
    ]
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    component: ChangePasswordComponent,
    data: { breadcrumb: 'no-bread-crumb' },

  },
  {
    path: 'home/:guId',
    component: SampleRequestNewComponent,
    data: { breadcrumb: 'no-bread-crumb' },
  },
  {
    path: 'sample-request-new',
    component: SampleRequestNewComponent,
    data: { breadcrumb: 'no-bread-crumb' },
  },



  /*SELF-SERVICE UTILITIES*/
  {
    path: 'self-service', canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }, children: [

      { path: 'sample-request', component: SampleRequestNewComponent, data: { breadcrumb: 'Sample Request' } },

    ]
  },


  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: { breadcrumb: 'unauthorized' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
